module.exports = function _has(prop, obj) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
};



//////////////////
// WEBPACK FOOTER
// ./~/coact/~/ramda/src/internal/_has.js
// module id = 1397
// module chunks = 0